module.exports = __webpack_public_path__ + "static/media/ow2.8f6b0e5d.webp";